import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    required: 'This field is required',
    numberOnly: 'Must be a number',
    integerOnly: 'Must be an integer',
    min: 'Minimum amount is {value} {unit}',
    maxBalance: 'Your balance is not sufficient',
    max: 'Maximum amount is {value} {unit}',
  },
};
